var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeIconMuted = function SvgVolumeIconMuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.333 8.334h1.5a1.5 1.5 0 0 0-2.437-1.172zM10 15v1.5a1.5 1.5 0 0 0 .937-.328zm-6.667 0v-1.5a1.5 1.5 0 0 0-1.5 1.5zm-1.5 8.334v1.5h3v-1.5zm16.5 8.333-.924 1.182a1.5 1.5 0 0 0 2.424-1.182zm-1.5-20.833v1.5h3v-1.5zm9.943 2 1.166-.943-1.885-2.334-1.166.943zM3.224 28l-1.167.942 1.885 2.334 1.167-.942zm6.337-3.19-.942-1.168zm7.835-17.648L9.063 13.83l1.874 2.343 8.333-6.667zM10 13.5H3.333v3H10zM1.833 15v8.334h3V15zm15-6.666v2.5h3v-2.5zm8.058 2.166-7.5 6.058 1.885 2.333 7.5-6.057zm-5.058 21.167V17.724h-3v13.943zm-2.442-15.11-8.772 7.086 1.885 2.333 8.772-7.085zm-8.772 7.086L3.224 28l1.885 2.334 5.395-4.358zm.018 2.348 8.772 6.858 1.848-2.364-8.772-6.857z"
  })));
};
export default SvgVolumeIconMuted;